import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { PageHeaderWrapper } from "@src/appV2/redesign/system/ui-components";

export function ShareScoreHeader() {
  return (
    <PageHeaderWrapper
      sx={{
        background: "transparent",
      }}
    >
      <PageHeaderTopRow fallbackGoBackPath="/home/clipboard-score" />
    </PageHeaderWrapper>
  );
}
